import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import FormValidationSummary, {
    mergeValidationErrors,
    validationMessage,
} from '../../../Shared/Components/FormValidationSummary'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const Reqd = () => <span className="text-danger">*</span>

const CatalogForm = ({ slug, title, entry }) => {
    const { flash, errors: pageErrors } = usePage().props
    const isEdit = Boolean(entry?.id)
    const [saving, setSaving] = useState(false)
    const showCode = slug === 'status' || slug === 'metodo-pago'

    const form = useForm({
        name: entry?.name || '',
        code: entry?.code || '',
        is_active: entry?.is_active ?? true,
        sort_order: entry?.sort_order ?? 0,
    })

    const allErrors = mergeValidationErrors(form.errors, pageErrors)
    const fieldError = (key) => validationMessage(allErrors, key)
    const invalidClass = (key) => (fieldError(key) ? 'is-invalid' : '')
    const FieldFeedback = ({ name }) =>
        fieldError(name) ? <div className="invalid-feedback d-block">{fieldError(name)}</div> : null

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = { preserveScroll: true, onFinish: () => setSaving(false) }

        if (isEdit) {
            form.put(route('cobranza.catalogs.update', [slug, entry.id]), opts)
        } else {
            form.post(route('cobranza.catalogs.store', slug), opts)
        }
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <FormValidationSummary errors={allErrors} />
            <span className="pb-7 pt-7">
                <Breadcrumbs
                    currentPath={
                        isEdit
                            ? `admin/cobranza/catalogos/${slug}/${entry.id}/edit`
                            : `admin/cobranza/catalogos/${slug}/create`
                    }
                />
            </span>

            <Card className="card-flush shadow-sm mb-10">
                <Card.Header className="pt-7">
                    <Card.Title className="fw-bold text-gray-800">
                        {isEdit ? `Editar — ${title}` : `Nuevo — ${title}`}
                    </Card.Title>
                </Card.Header>
                <Card.Body className="py-8 px-6 px-lg-10">
                    <Form onSubmit={submit}>
                        <Row className="g-6">
                            <Col md={6}>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">
                                        Nombre <Reqd />
                                    </Form.Label>
                                    <Form.Control
                                        value={form.data.name}
                                        onChange={(e) => form.setData('name', e.target.value)}
                                        className={invalidClass('name')}
                                    />
                                    <FieldFeedback name="name" />
                                </div>
                            </Col>
                            {showCode && (
                                <Col md={6}>
                                    <div className="mb-4">
                                        <Form.Label className="fw-bold">Código</Form.Label>
                                        <Form.Control
                                            value={form.data.code}
                                            onChange={(e) => form.setData('code', e.target.value)}
                                            className={invalidClass('code')}
                                            placeholder="Opcional"
                                        />
                                        <FieldFeedback name="code" />
                                    </div>
                                </Col>
                            )}
                            <Col md={6}>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">
                                        Orden <Reqd />
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        min={0}
                                        value={form.data.sort_order}
                                        onChange={(e) => form.setData('sort_order', e.target.value)}
                                        className={invalidClass('sort_order')}
                                    />
                                    <FieldFeedback name="sort_order" />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-4 pt-8">
                                    <Form.Check
                                        type="switch"
                                        id="is_active"
                                        label="Activo"
                                        checked={!!form.data.is_active}
                                        onChange={(e) => form.setData('is_active', e.target.checked)}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div className="d-flex gap-3 mt-6">
                            <Button type="submit" variant="primary" disabled={saving || form.processing}>
                                {saving ? 'Guardando…' : 'Guardar'}
                            </Button>
                            <Link href={route('cobranza.catalogs.index', slug)} className="btn btn-light">
                                Cancelar
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Row>
    )
}

CatalogForm.layout = (page) => (
    <Layout title={`Cobranza — ${page.props.title}`}>{page}</Layout>
)

export default CatalogForm
